import React from 'react'
import Card from "@material-ui/core/Card";
import Alert from "@material-ui/lab/Alert";
import Colors from "../../config/colors";
import {getFullNameEnSuspensions} from "../../helpers/Helpers";

class SuspensionsList extends React.Component {

    render() {

        const {data} = this.props;

        if (data.length === 0) {
            return (
                <div style={{paddingLeft: '30px', paddingRight: '30px'}}>
                    <br/>
                    <Alert severity="info">No se encontraron registros de suspensión para esta cuenta.</Alert>
                </div>
            );
        }

        return (
            <div style={{width: '60%', margin: 'auto'}}>
                <Card style={{padding: '20px'}}>
                    <table className='custom-table'>
                        <tbody>
                        <tr>
                            <th>No.</th>
                            <th>Fecha</th>
                            <th>En</th>
                            <th>Observación</th>
                        </tr>
                        {data.map((val, index) => {
                            return (
                                <tr key={index}>
                                    <td><span style={{
                                        background: Colors.primary,
                                        color: 'white',
                                        padding: '5px',
                                        borderRadius: '10px'
                                    }}><b>{val.NUMERO_DOCUMENTO}</b></span></td>
                                    <td>{val.FECHA_ACCION}</td>
                                    <td>{getFullNameEnSuspensions(val.SUSPENSION_EN)}</td>
                                    <td>{val.OBSERVACIONES}</td>
                                </tr>
                            );
                        })}
                        </tbody>
                    </table>
                </Card>
            </div>
        );
    }
}

export default SuspensionsList